import { isEqual } from "lodash";
import { useState, useMemo, useCallback } from "react";

import { PeriodQuickFilter, Period } from "./interfaces";

export const usePeriodFromToQuickFilter = () => {
  const TODAY: { thisYear: number; thisMonth: number } = useMemo(() => {
    const today = new Date();

    return {
      thisYear: today.getFullYear(),
      thisMonth: today.getMonth(),
    };
  }, []);

  const [quickFilter, setQuickFilter] = useState<PeriodQuickFilter>({
    period: null,
  });

  const handleChangeQuickFilter = useCallback(
    (filter: keyof PeriodQuickFilter, value: Period | null) => {
      if (isEqual(value, quickFilter[filter])) return;
      setQuickFilter((state) => ({
        ...state,
        [filter]: value,
      }));
    },
    [quickFilter]
  );

  return {
    periodFromToQuickFilter: quickFilter,
    setPeriodFromToQuickFilter: handleChangeQuickFilter,
  };
};
